<template>
  <div id="orderIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">订单</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from "components/layout/SecondMenu";
import { getDBModuleStatusPermission, getDBOperationPermission } from "common/js/storage";
export default {
  data() {
    return {
      authorityList: [],
      secondaryMenuMap: [
        {
          menuName: "订货单",
          url: "/admin/order/order-form",
          keyword: "ROLE_ORDER_show",
          childrenMenu: [],
        },
        {
          menuName: "退货单",
          url: "/admin/order/return-form",
          keyword: "ROLE_ORDER_cancel_show",
          childrenMenu: [],
        },
        {
          menuName: "选品单",
          url: "/admin/order/select-form",
          keyword: "",
          childrenMenu: [],
        },
        {
          menuName: "返修单",
          url: "/admin/order/repair-form",
          keyword: "ROLE_ORDER_repair_search",
          childrenMenu: [],
        },
      ],
    };
  },
  created() {
    this.authorityList = getDBOperationPermission()
    if (getDBModuleStatusPermission().moduleSelection === 0) {
      this.secondaryMenuMap.splice(2, 1);
    }
    if (getDBModuleStatusPermission().moduleRepair === 0) {
      this.secondaryMenuMap.splice(this.secondaryMenuMap.length -1, 1);
    } else {
      if (
        this.authorityList.indexOf("ROLE_ORDER_repair_search") === -1
      ) {
        this.secondaryMenuMap.splice(this.secondaryMenuMap.length -1, 1);
      }
    }
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      this.$router.push({
        path: url,
      });
    },
  },
  components: {
    SecondMenu,
  },
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
